import { css } from 'goober';
import { isFunction } from 'mc-ui-utils';
import React from 'react';
import { STICKER_TRAY_ELEMENTS } from '../../constants/interaction';
import State from '../../state';
import colors from '../../styles/colors';
import { HeartBeat, HeartIcon, HeartShell } from '../Heart';
import IconAnimation from '../IconAnimation';
import IconBubbles from '../IconBubbles';
import ShareIcon from '../ShareIcon';
import WhatsappIcon from '../WhatsappIcon';
const Container = css `
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
`;
const Sticker = (src, width = 30, height = 30) => css `
  width: ${width}px;
  height: ${height}px;
  background-size: 100%;
  background-image: url('${src}');
  background-repeat: no-repeat;
  filter: drop-shadow(0px 4px 12px rgba(244, 125, 33, 0.4));
  position: relative;
`;
const HeartAnimateContainer = css `
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
`;
const EmojiInteractor = (props) => {
    const { onLike, onShare, onSendAnalytics } = props;
    const handleClick = (emojiId, callback) => () => {
        if (isFunction(callback)) {
            callback();
        }
        onSendAnalytics({
            variant: "emoticons" /* EMOTICONS */,
            action: `emoji selected with emoji id - ${emojiId}`,
        });
    };
    return (React.createElement("div", { className: Container },
        React.createElement(IconAnimation, { icon: React.createElement(HeartShell, { width: 36, height: 36 },
                React.createElement(HeartBeat, null,
                    React.createElement(HeartIcon, { liked: false }))), animateicon: React.createElement("div", { className: HeartAnimateContainer },
                React.createElement(HeartBeat, null,
                    React.createElement(HeartIcon, { liked: false })),
                React.createElement(IconBubbles, { color: colors.heartGradient })), onClick: handleClick("heart" /* HEART */, onLike) }),
        React.createElement(IconAnimation, { icon: React.createElement("div", { className: Sticker(STICKER_TRAY_ELEMENTS[1], 54, 54) }), animateicon: React.createElement("div", { className: Sticker(STICKER_TRAY_ELEMENTS[1]) },
                React.createElement(IconBubbles, { color: colors.yellowGradient })), onClick: handleClick("starry_eyes_face" /* STARRY_EYES_FACE */) }),
        React.createElement(IconAnimation, { icon: React.createElement("div", { className: Sticker(STICKER_TRAY_ELEMENTS[2], 54, 54) }), animateicon: React.createElement("div", { className: Sticker(STICKER_TRAY_ELEMENTS[2]) },
                React.createElement(IconBubbles, { color: colors.yellowGradient })), onClick: handleClick("grinning_face" /* GRINNING_FACE */) }),
        React.createElement(IconAnimation, { icon: React.createElement("div", { className: Sticker(STICKER_TRAY_ELEMENTS[3], 54, 54) }), animateicon: React.createElement("div", { className: Sticker(STICKER_TRAY_ELEMENTS[3]) },
                React.createElement(IconBubbles, { color: colors.yellowGradient })), onClick: handleClick("cool_face" /* COOL_FACE */) }),
        State.hasWhatsAppInstalled ? (React.createElement("div", { onClick: handleClick("whatsapp_share" /* WHATSAPP */, onShare) },
            React.createElement(WhatsappIcon, { width: 36, height: 36 }))) : (React.createElement("div", { onClick: handleClick("generic_share" /* SHARE */, onShare) },
            React.createElement(ShareIcon, { width: 36, height: 36 })))));
};
export default EmojiInteractor;
//# sourceMappingURL=index.js.map